/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    TextField,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    FormHelperText,
    OutlinedInput,
    ListItemText,
    Checkbox,
    Typography,
    Autocomplete,
    FormLabel,
    IconButton,
    Collapse,
    RadioGroup,
    FormControlLabel,
    Radio,
    Chip
} from '@mui/material';
import { Field, ErrorMessage } from 'formik';
import SubCard from 'ui-component/cards/SubCard';
import { gridSpacing, roles } from 'store/constant';
import {
    constructionMaterials,
    parkingFeatures,
    lotFeatures,
    waterBodyName,
    foundationDetails,
    view,
    unitStyle,
    roof,
    flooring,
    restrictions,
    parkingFeeFrequency
} from './data/general_data';
import { tips } from './HelpData';
import HelpIcon from './HelpIcon';
import useAuth from 'hooks/useAuth';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import axiosServices from 'utils/axios';

const ownershipType = ['Common', 'Fee-Simple', 'Fractional', 'See Remarks'];
const propertySubTypes = [
    'Single Family Residence',
    'Condominium',
    'Apartment',
    'Manufactured Home',
    'Mobile Home',
    'Modular',
    'Townhouse',
    'See Remarks'
];
const levels = ['1', '1.5', '2', '3+', 'Multi/Split'];
const yearBuiltSource = ['Appraiser', 'Builder', 'Estimated', 'Owner', 'Public Records', 'See Remarks'];
const livingAreaSource = ['Appraiser', 'Builder', 'Multiple Dwelling', 'Owner', 'Plans', 'Public Records', 'See Remarks'];
const directionFaces = ['East', 'North', 'North-East', 'North-West', 'South', 'South-East', 'South-West', 'West'];
const distanceToWaterAccess = ['Less Than 1 Mile', '1-2 Miles', '2+ Miles', 'In Subdivision', 'See Remarks'];
const propertyCondition = [
    'Historic Design',
    'New Construction',
    'Resale',
    'Tear Down',
    'To Be Built',
    'Under Construction',
    'Updated/Remodeled',
    'See Remarks'
];
const waterfrontFeatures = [
    'Canal Front',
    'Creek',
    'Dry/Seasonal',
    'Lake Front',
    'Lake Privileges',
    'Pond',
    'River Front',
    'Stream',
    'Waterfront',
    'None',
    'See Remarks'
];

const General = ({ role, errors, handleChange, handleBlur, values, touched, setFieldValue, propertyContacts, handleRegionalChange }) => {
    const user = useAuth();
    const [openOptional, setOpenOptional] = useState(true);
    // const [complexList, setComplexList] = useState([]);

    // Fetch the list of complexes from your backend API
    // useEffect(() => {
    //     const fetchComplexes = async () => {
    //     try {
    //         const { data } = await axiosServices.get('/complex', {
    //         headers: {
    //             authorization: `Bearer ${localStorage.getItem('serviceToken')}`
    //         }
    //         });
    //         // Assuming your backend returns { complexes: [...] }
    //         setComplexList(data.complexes || []);
    //     } catch (error) {
    //         toast.error('Error fetching complex list');
    //     }
    //     };

    //     fetchComplexes();
    // }, []);


    const handleToggle = () => {
        setOpenOptional((prev) => !prev);
    };

    return (
        <>
            <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <Typography
                            sx={{
                                color: '#919191',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                                mb: 2
                            }}
                        >
                            General Information
                        </Typography>
                        <SubCard>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth required error={touched.propertySubTypes && Boolean(errors.propertySubTypes)}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Property Sub Type
                                                </Typography>
                                            </FormLabel>

                                            <HelpIcon
                                                title={tips?.propertySubTypes.title}
                                                ruleHelp={tips?.propertySubTypes.ruleHelp}
                                                generalHelpDesc={tips?.propertySubTypes.generalHelpDesc}
                                            />
                                        </Box>

                                        <Autocomplete
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option}
                                                        {...getTagProps({ index })}
                                                        sx={{
                                                            '& .MuiChip-deleteIcon': {
                                                                color: 'black !important'
                                                            }
                                                        }}
                                                    />
                                                ))
                                            }
                                            id="propertySubTypes"
                                            fullWidth
                                            options={propertySubTypes}
                                            value={values.propertySubTypes}
                                            onChange={(event, newValue) => {
                                                setFieldValue('propertySubTypes', newValue);
                                            }}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    name="propertySubTypes"
                                                    error={touched.propertySubTypes && Boolean(errors.propertySubTypes)}
                                                    helperText={touched.propertySubTypes && errors.propertySubTypes}
                                                    InputProps={{ ...params.InputProps, endAdornment: params.InputProps.endAdornment }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth required error={touched.levels && Boolean(errors.levels)}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Levels
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.levels.title}
                                                ruleHelp={tips?.levels.ruleHelp}
                                                generalHelpDesc={tips?.levels.generalHelpDesc}
                                                generalHelp={tips?.levels.generalHelp}
                                            />
                                        </Box>

                                        <Autocomplete
                                            multiple
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option}
                                                        {...getTagProps({ index })}
                                                        sx={{
                                                            '& .MuiChip-deleteIcon': {
                                                                color: 'black !important'
                                                            }
                                                        }}
                                                    />
                                                ))
                                            }
                                            disableCloseOnSelect
                                            id="levels"
                                            options={levels}
                                            value={values.levels}
                                            onChange={(event, newValue) => {
                                                setFieldValue('levels', newValue);
                                            }}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    name="levels"
                                                    error={touched.levels && Boolean(errors.levels)}
                                                    helperText={touched.levels && errors.levels}
                                                />
                                            )}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                    <ListItemText primary={option} />
                                                </li>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required error={touched.ownershipType && Boolean(errors.ownershipType)} sx={{ mt: 2 }}>
                                <InputLabel>Ownership Type</InputLabel>
                                <Select
                                    id="ownershipType"
                                    name="ownershipType"
                                    label="Ownership Type"
                                    value={values.ownershipType}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    input={<OutlinedInput label="Ownership Type" />}
                                >
                                    {ownershipType.map((option) => (
                                        <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                {touched.ownershipType && errors.ownershipType && <FormHelperText>{errors.ownershipType}</FormHelperText>}
                            </FormControl>
                        </Grid> */}
                            </Grid>
                        </SubCard>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Bedrooms
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Main Level Bedrooms
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.mainLevelBedrooms.title}
                                                ruleHelp={tips?.mainLevelBedrooms.ruleHelp}
                                                generalHelpDesc={tips?.mainLevelBedrooms.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            name="mainLevelBedrooms"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.mainLevelBedrooms}
                                            error={touched.mainLevelBedrooms && errors.mainLevelBedrooms}
                                            helperText={<ErrorMessage name="mainLevelBedrooms" />}
                                        />

                                        {/* {touched.mainLevelBedrooms && errors.mainLevelBedrooms && (
                                            <FormHelperText error>{errors.mainLevelBedrooms}</FormHelperText>
                                        )} */}
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Bathrooms
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Bathrooms Full
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.bathroomsFull.title}
                                                ruleHelp={tips?.bathroomsFull.ruleHelp}
                                                generalHelpDesc={tips?.bathroomsFull.generalHelpDesc}
                                            />
                                        </Box>

                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            name="bathroomsFull"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.bathroomsFull}
                                            error={touched.bathroomsFull && errors.bathroomsFull}
                                            helperText={<ErrorMessage name="bathroomsFull" />}
                                        />

                                        {/* {touched.bathroomsFull && errors.bathroomsFull && (
                                            <FormHelperText error>{errors.bathroomsFull}</FormHelperText>
                                        )} */}
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Bathrooms Half
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.bathroomsHalf.title}
                                                ruleHelp={tips?.bathroomsHalf.ruleHelp}
                                                generalHelpDesc={tips?.bathroomsHalf.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            name="bathroomsHalf"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.bathroomsHalf}
                                            error={touched.bathroomsHalf && errors.bathroomsHalf}
                                            helperText={<ErrorMessage name="bathroomsHalf" />}
                                        />

                                        {/* {touched.bathroomsHalf && errors.bathroomsHalf && (
                                            <FormHelperText error>{errors.bathroomsHalf}</FormHelperText>
                                        )} */}
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Year Built
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Year Built
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.yearBuilt.title}
                                                ruleHelp={tips?.yearBuilt.ruleHelp}
                                                generalHelpDesc={tips?.yearBuilt.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            type="number"
                                            name="yearBuilt"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.yearBuilt}
                                            error={touched.yearBuilt && errors.yearBuilt}
                                            helperText={<ErrorMessage name="yearBuilt" />}
                                        />

                                        {/* {touched.yearBuilt && errors.yearBuilt && <FormHelperText error>{errors.yearBuilt}</FormHelperText>} */}
                                    </Grid>
                                    {/* <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth required error={touched.yearBuiltSource && Boolean(errors.yearBuiltSource)}>
                                            <InputLabel>Year Built Source</InputLabel>
                                            <Select
                                                id="yearBuiltSource"
                                                name="yearBuiltSource"
                                                label="Year Built Source"
                                                value={values.yearBuiltSource}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                input={<OutlinedInput label="Year Built Source" />}
                                            >
                                                {yearBuiltSource.map((option) => (
                                                    <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                        <ListItemText primary={option} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.yearBuiltSource && errors.yearBuiltSource && (
                                                <FormHelperText>{errors.yearBuiltSource}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid> */}
                                </Grid>
                            </SubCard>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Living Area
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    # of Living Rooms
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.living.title}
                                                ruleHelp={tips?.living.ruleHelp}
                                                generalHelpDesc={tips?.living.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            name="living"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.living}
                                            error={touched.living && errors.living}
                                            helperText={<ErrorMessage name="living" />}
                                        />

                                        {/* {touched.living && errors.living && <FormHelperText error>{errors.living}</FormHelperText>} */}
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Living Area (SqFt)
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.livingArea.title}
                                                ruleHelp={tips?.livingArea.ruleHelp}
                                                generalHelpDesc={tips?.livingArea.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            name="livingArea"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.livingArea}
                                            error={touched.livingArea && errors.livingArea}
                                            helperText={<ErrorMessage name="livingArea" />}
                                        />

                                        {/* {touched.livingArea && errors.livingArea && (
                                            <FormHelperText error>{errors.livingArea}</FormHelperText>
                                        )} */}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    # of Dining Rooms
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.dining.title}
                                                ruleHelp={tips?.dining.ruleHelp}
                                                generalHelpDesc={tips?.dining.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            name="dining"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.dining}
                                            error={touched.dining && errors.dining}
                                            helperText={<ErrorMessage name="dining" />}
                                        />

                                        {/* {touched.dining && errors.dining && <FormHelperText error>{errors.dining}</FormHelperText>} */}
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormControl
                                            fullWidth
                                            required
                                            error={touched.livingAreaSource && Boolean(errors.livingAreaSource)}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Living Area Source
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.livingAreaSource.title}
                                                    ruleHelp={tips?.livingAreaSource.ruleHelp}
                                                    generalHelpDesc={tips?.livingAreaSource.generalHelpDesc}
                                                    generalHelp={tips?.livingAreaSource.generalHelp}
                                                />
                                            </Box>
                                            <RadioGroup
                                                aria-label="livingAreaSource"
                                                name="livingAreaSource"
                                                value={values.livingAreaSource}
                                                onChange={handleChange}
                                                row
                                                sx={{ gap: 1, ml: 1, mt: 1 }}
                                            >
                                                {livingAreaSource.map((option) => (
                                                    <FormControlLabel
                                                        key={option}
                                                        value={option}
                                                        control={<Radio />}
                                                        label={option}
                                                        sx={{
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            padding: '2px 14px',
                                                            minWidth: '180px'
                                                        }}
                                                    />
                                                ))}
                                            </RadioGroup>

                                            {touched.livingAreaSource && errors.livingAreaSource && (
                                                <FormHelperText>{errors.livingAreaSource}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth required error={touched.smokingInside && Boolean(errors.smokingInside)}>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Is Smoking Allowed?
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.smokingInside.title}
                                                    ruleHelp={tips?.smokingInside.ruleHelp}
                                                    generalHelpDesc={tips?.smokingInside.generalHelpDesc}
                                                />
                                            </Box>

                                            <RadioGroup
                                                aria-label="smokingInside-label"
                                                name="smokingInside"
                                                value={values.smokingInside}
                                                onChange={handleChange}
                                                row
                                                sx={{ gap: 1, ml: 1, mt: 1 }}
                                            >
                                                {['Yes', 'No'].map((option) => (
                                                    <FormControlLabel
                                                        key={option}
                                                        value={option}
                                                        control={<Radio />}
                                                        label={option}
                                                        sx={{
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            padding: '2px 14px',
                                                            minWidth: '180px'
                                                        }}
                                                    />
                                                ))}
                                            </RadioGroup>

                                            {touched.smokingInside && errors.smokingInside && (
                                                <FormHelperText>Smoking Inside? is required</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Parking Areas
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Parking Total
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.parkingTotal.title}
                                                ruleHelp={tips?.parkingTotal.ruleHelp}
                                                generalHelpDesc={tips?.parkingTotal.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            type="number"
                                            name="parkingTotal"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.parkingTotal}
                                            error={touched.parkingTotal && errors.parkingTotal}
                                            helperText={<ErrorMessage name="parkingTotal" />}
                                        />

                                        {/* {touched.parkingTotal && errors.parkingTotal && (
                                            <FormHelperText error>{errors.parkingTotal}</FormHelperText>
                                        )} */}
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth required error={touched.parkingFeatures && Boolean(errors.parkingFeatures)}>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Parking Features
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.parkingFeatures.title}
                                                    ruleHelp={tips?.parkingFeatures.ruleHelp}
                                                    generalHelpDesc={tips?.parkingFeatures.generalHelpDesc}
                                                    generalHelp={tips?.parkingFeatures.generalHelp}
                                                />
                                            </Box>

                                            <Autocomplete
                                                disableCloseOnSelect
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                id="parkingFeatures"
                                                options={parkingFeatures}
                                                value={values.parkingFeatures}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('parkingFeatures', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="parkingFeatures"
                                                        error={touched.parkingFeatures && Boolean(errors.parkingFeatures)}
                                                        helperText={touched.parkingFeatures && errors.parkingFeatures}
                                                    />
                                                )}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>

                        {/* <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Complex Details
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Complex Name
                                            </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                            title={tips?.complexName.title}
                                            ruleHelp={tips?.complexName.ruleHelp}
                                            generalHelpDesc={tips?.complexName.generalHelpDesc}
                                            />
                                        </Box>

                                        <Autocomplete
                                            id="complex"
                                            options={complexList} // an array of objects like [{ id: 'abc', name: 'Complex A' }, ...]
                                            getOptionLabel={(option) => option.name}
                                            value={
                                            values.complexId
                                                ? complexList.find((c) => c.id === values.complexId) || null
                                                : null
                                            }
                                            onChange={(event, newValue) => {
                                            // Save both complex id and name into Formik values
                                            setFieldValue('complex_id', newValue ? newValue.id : '');
                                            setFieldValue('complexName', newValue ? newValue.name : '');
                                            }}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="complexName"
                                                variant="outlined"
                                                error={touched.complexName && Boolean(errors.complexName)}
                                                helperText={touched.complexName && errors.complexName}
                                            />
                                            )}
                                        />
                                        </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Units in Complex
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.unitsInComplex.title}
                                                ruleHelp={tips?.unitsInComplex.ruleHelp}
                                                generalHelpDesc={tips?.unitsInComplex.generalHelpDesc}
                                            />
                                        </Box>

                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            name="unitsInComplex"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.unitsInComplex}
                                            error={touched.unitsInComplex && errors.unitsInComplex}
                                            helperText={<ErrorMessage name="unitsInComplex" />}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Floor Plan Name/Number
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.floorPlanName.title}
                                                ruleHelp={tips?.floorPlanName.ruleHelp}
                                                generalHelpDesc={tips?.floorPlanName.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            name="floorPlanName"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.floorPlanName}
                                            error={touched.floorPlanName && errors.floorPlanName}
                                            helperText={<ErrorMessage name="floorPlanName" />}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth required error={touched.smokingInside && Boolean(errors.smokingInside)}>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Is Smoking Allowed?
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.smokingInside.title}
                                                    ruleHelp={tips?.smokingInside.ruleHelp}
                                                    generalHelpDesc={tips?.smokingInside.generalHelpDesc}
                                                />
                                            </Box>

                                            <RadioGroup
                                                aria-label="smokingInside-label"
                                                name="smokingInside"
                                                value={values.smokingInside}
                                                onChange={handleChange}
                                                row
                                                sx={{ gap: 1, ml: 1, mt: 1 }}
                                            >
                                                {['Yes', 'No'].map((option) => (
                                                    <FormControlLabel
                                                        key={option}
                                                        value={option}
                                                        control={<Radio />}
                                                        label={option}
                                                        sx={{
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            padding: '2px 14px',
                                                            minWidth: '180px'
                                                        }}
                                                    />
                                                ))}
                                            </RadioGroup>

                                            {touched.smokingInside && errors.smokingInside && (
                                                <FormHelperText>Smoking Inside? is required</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid> */}

                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Listing Access
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    {user?.role !== 'REGIONAL_MANAGER' && (
                                        <Grid item xs={12} sm={6}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    {user?.role === 'MARKETING_MANAGER'
                                                        ? 'Marketing Manager'
                                                        : 'Regional/Marketing Manager'}
                                                </Typography>
                                            </FormLabel>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        multiple
                                                        renderTags={(tagValue, getTagProps) =>
                                                            tagValue.map((option, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    label={option}
                                                                    {...getTagProps({ index })}
                                                                    sx={{
                                                                        '& .MuiChip-deleteIcon': {
                                                                            color: 'black !important'
                                                                        }
                                                                    }}
                                                                />
                                                            ))
                                                        }
                                                        id="regionalAccess"
                                                        options={propertyContacts?.secondary || []}
                                                        value={
                                                            values?.regionalAccess?.map((id) =>
                                                                propertyContacts?.secondary?.find((e) => e?.id === id)
                                                            ) || []
                                                        }
                                                        onChange={(event, newValue) => {
                                                            const selectedValues = newValue.map((option) => option.id);

                                                            if (role === roles.ADMIN) {
                                                                handleRegionalChange(selectedValues);
                                                            }
                                                            handleChange({
                                                                target: {
                                                                    name: 'regionalAccess',
                                                                    value: selectedValues
                                                                }
                                                            });
                                                        }}
                                                        onBlur={handleBlur}
                                                        getOptionLabel={(option) =>
                                                            `${option?.firstName} ${option?.lastName ?? ''} (${option?.email})`
                                                        }
                                                        renderTags={(selected, getTagProps) =>
                                                            selected.map((option, index) => (
                                                                <span {...getTagProps({ index })}>
                                                                    {`${option.firstName} ${option.lastName ?? ''} (${option.email})`}
                                                                </span>
                                                            ))
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                error={touched.regionalAccess && Boolean(errors.regionalAccess)}
                                                                helperText={
                                                                    errors.regionalAccess && 'At least one of the two fields must be filled'
                                                                }
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                    )}
                                    {user?.role !== 'APARTMENT_MANAGER' && (
                                        <Grid item xs={12} sm={6}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    {user?.role === 'MARKETING_MANAGER'
                                                        ? 'Regional/Apartment Manager'
                                                        : 'Apartment Manager'}
                                                </Typography>
                                            </FormLabel>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl fullWidth error={touched.apartmentAccess && Boolean(errors.apartmentAccess)}>
                                                    <Autocomplete
                                                        multiple
                                                        renderTags={(tagValue, getTagProps) =>
                                                            tagValue.map((option, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    label={option}
                                                                    {...getTagProps({ index })}
                                                                    sx={{
                                                                        '& .MuiChip-deleteIcon': {
                                                                            color: 'black !important'
                                                                        }
                                                                    }}
                                                                />
                                                            ))
                                                        }
                                                        id="apartmentAccess"
                                                        options={propertyContacts?.primary || []}
                                                        value={
                                                            values?.apartmentAccess?.map((id) =>
                                                                propertyContacts?.primary?.find((e) => e?.id === id)
                                                            ) || []
                                                        }
                                                        onChange={(event, newValue) => {
                                                            handleChange({
                                                                target: {
                                                                    name: 'apartmentAccess',
                                                                    value: newValue.map((option) => option.id)
                                                                }
                                                            });
                                                        }}
                                                        onBlur={handleBlur}
                                                        getOptionLabel={(option) =>
                                                            `${option?.firstName} ${option?.lastName ?? ''} (${option?.email})`
                                                        }
                                                        renderTags={(selected, getTagProps) =>
                                                            selected.map((option, index) => (
                                                                <Typography {...getTagProps({ index })}>
                                                                    {`${option.firstName} ${option.lastName ?? ''}`}
                                                                </Typography>
                                                            ))
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                error={touched.apartmentAccess && Boolean(errors.apartmentAccess)}
                                                                helperText={
                                                                    (errors.apartmentAccess || errors.regionalAccess) &&
                                                                    'At least one of the two fields must be filled'
                                                                }
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                    )}
                                </Grid>
                            </SubCard>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Additional Areas
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Garage Spaces
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.garageSpaces.title}
                                                ruleHelp={tips?.garageSpaces.ruleHelp}
                                                generalHelpDesc={tips?.garageSpaces.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            required
                                            type="number"
                                            name="garageSpaces"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.garageSpaces}
                                            error={touched.garageSpaces && errors.garageSpaces}
                                            helperText={<ErrorMessage name="garageSpaces" />}
                                        />

                                        {/* {touched.garageSpaces && errors.garageSpaces && (
                                            <FormHelperText error>{errors.garageSpaces}</FormHelperText>
                                        )} */}
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth required error={touched.directionFaces && Boolean(errors.directionFaces)}>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Direction Faces
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.directionFaces.title}
                                                    ruleHelp={tips?.directionFaces.ruleHelp}
                                                    generalHelpDesc={tips?.directionFaces.generalHelpDesc}
                                                />
                                            </Box>

                                            <Autocomplete
                                                id="directionFaces"
                                                options={directionFaces}
                                                value={values.directionFaces}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('directionFaces', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="directionFaces"
                                                        error={touched.directionFaces && Boolean(errors.directionFaces)}
                                                        helperText={touched.directionFaces && errors.directionFaces}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth required error={touched.lotFeatures && Boolean(errors.lotFeatures)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Lot Features
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.lotFeatures.title}
                                                    ruleHelp={tips?.lotFeatures.ruleHelp}
                                                    generalHelpDesc={tips?.lotFeatures.generalHelpDesc}
                                                    generalHelp={tips?.lotFeatures.generalHelp}
                                                />
                                            </Box>

                                            <Autocomplete
                                                disableCloseOnSelect
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                id="lotFeatures"
                                                options={lotFeatures}
                                                value={values.lotFeatures}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('lotFeatures', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="lotFeatures"
                                                        error={touched.lotFeatures && Boolean(errors.lotFeatures)}
                                                        helperText={touched.lotFeatures && errors.lotFeatures}
                                                    />
                                                )}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>

                        {/* <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Water Supply
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}></Grid>
                            </SubCard>
                        </Grid> */}

                        {/* <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                    textTransform: 'capitalize',
                                    mb: 2
                                }}
                            >
                                Additional Property Info
                            </Typography>
                            <SubCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControl fullWidth required error={touched.flooring && Boolean(errors.flooring)}>
                                                <InputLabel>Flooring Details</InputLabel>
                                                <Select
                                                    label="Flooring Details"
                                                    multiple
                                                      renderTags={(tagValue, getTagProps) =>
                                                        tagValue.map((option, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={option}
                                                                {...getTagProps({ index })}
                                                                sx={{
                                                                    '& .MuiChip-deleteIcon': {
                                                                        color: 'black !important'
                                                                    }
                                                                }}
                                                            />
                                                        ))
                                                    }
                                                    value={values.flooring}
                                                    onChange={(event) => {
                                                        setFieldValue('flooring', event.target.value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    input={<OutlinedInput label="Flooring Details" />}
                                                    renderValue={(selected) => selected.join(', ')}
                                                >
                                                    {flooring.map((option) => (
                                                        <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                            <Checkbox checked={values.flooring.includes(option)} />
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.flooring && errors.flooring && <FormHelperText>{errors.flooring}</FormHelperText>}
                                            </FormControl>
                                            <HelpIcon
                                                title={tips?.flooring.title}
                                                ruleHelp={tips?.flooring.ruleHelp}
                                                generalHelpDesc={tips?.flooring.generalHelpDesc}
                                                generalHelp={tips?.flooring.generalHelp}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControl fullWidth required error={touched.restrictions && Boolean(errors.restrictions)}>
                                                <InputLabel>Restrictions</InputLabel>
                                                <Select
                                                    label="Restrictions"
                                                    multiple
                                                    value={values.restrictions}
                                                    onChange={(event) => {
                                                        setFieldValue('restrictions', event.target.value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    input={<OutlinedInput label="Restrictions" />}
                                                    renderValue={(selected) => selected.join(', ')}
                                                >
                                                    {restrictions.map((option) => (
                                                        <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                            <Checkbox checked={values.restrictions.includes(option)} />
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.restrictions && errors.restrictions && (
                                                    <FormHelperText>{errors.restrictions}</FormHelperText>
                                                )}
                                            </FormControl>
                                            <HelpIcon
                                                title={tips?.restrictions.title}
                                                ruleHelp={tips?.restrictions.ruleHelp}
                                                // generalHelpDesc={tips?.restrictions.generalHelpDesc}
                                                // generalHelp={tips?.restrictions.generalHelp}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid> */}
                    </Grid>

                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                cursor: 'pointer',
                                mb: 2,
                                p: 1,
                                background: 'white'
                            }}
                            onClick={handleToggle}
                        >
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    textTransform: 'capitalize'
                                }}
                            >
                                Optional Information
                            </Typography>
                            <IconButton>{openOptional ? <ExpandLess /> : <ExpandMore />}</IconButton>
                        </Box>
                        <Collapse in={openOptional}>
                            <SubCard>
                                <Grid container spacing={2}>
                                    {role === roles.ADMIN && (
                                        <Grid item xs={12} sm={4}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Also Listed As (enter ML#)
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.alsoListedAs.title}
                                                    ruleHelp={tips?.alsoListedAs.ruleHelp}
                                                    // generalHelpDesc={tips?.alsoListedAs.generalHelpDesc}
                                                    // generalHelp={tips?.alsoListedAs.generalHelp}
                                                />
                                            </Box>
                                            <TextField
                                                sx={{ mt: 1 }}
                                                fullWidth
                                                name="alsoListedAs"
                                                value={values.alsoListedAs}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />

                                            {touched.alsoListedAs && errors.alsoListedAs && (
                                                <FormHelperText error>{errors.alsoListedAs}</FormHelperText>
                                            )}
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth error={touched.moveInSpecialYN && Boolean(errors.moveInSpecialYN)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Move in Special YN
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.moveInSpecialYN.title}
                                                    ruleHelp={tips?.moveInSpecialYN.ruleHelp}
                                                    generalHelpDesc={tips?.moveInSpecialYN.generalHelpDesc}
                                                />
                                            </Box>

                                            <RadioGroup
                                                aria-label="moveInSpecialYN"
                                                name="moveInSpecialYN"
                                                value={values.moveInSpecialYN}
                                                onChange={handleChange}
                                                row
                                                sx={{ gap: 1, ml: 1, mt: 1 }}
                                            >
                                                {/* Yes */}
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={<Radio />}
                                                    label="Yes"
                                                    sx={{
                                                        border: '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        padding: '2px 14px',
                                                        minWidth: '120px'
                                                    }}
                                                />

                                                {/* No */}
                                                <FormControlLabel
                                                    value="No"
                                                    control={<Radio />}
                                                    label="No"
                                                    sx={{
                                                        border: '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        padding: '2px 14px',
                                                        minWidth: '120px'
                                                    }}
                                                />
                                            </RadioGroup>

                                            {touched.moveInSpecialYN && errors.moveInSpecialYN && (
                                                <FormHelperText sx={{ color: 'red' }}>{errors.moveInSpecialYN}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Other Level Beds
                                            </Typography>
                                        </FormLabel>
                                        <TextField
                                            fullWidth
                                            name="otherLevelBeds"
                                            type="number"
                                            value={values.otherLevelBeds}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.otherLevelBeds && errors.otherLevelBeds && (
                                            <FormHelperText error>{errors.otherLevelBeds}</FormHelperText>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Parking Fee From $
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.parkingFeeFrom.title}
                                                ruleHelp={tips?.parkingFeeFrom.ruleHelp}
                                                generalHelpDesc={tips?.parkingFeeFrom.generalHelpDesc}
                                            />
                                        </Box>
                                        <TextField
                                            fullWidth
                                            name="parkingFeeFrom"
                                            value={values.parkingFeeFrom}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                        {touched.parkingFeeFrom && errors.parkingFeeFrom && (
                                            <FormHelperText error>{errors.parkingFeeFrom}</FormHelperText>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Parking Fee To $
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.parkingFeeTo.title}
                                                ruleHelp={tips?.parkingFeeTo.ruleHelp}
                                                generalHelpDesc={tips?.parkingFeeTo.generalHelpDesc}
                                            />
                                        </Box>
                                        <TextField
                                            fullWidth
                                            name="parkingFeeTo"
                                            value={values.parkingFeeTo}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                        {touched.parkingFeeTo && errors.parkingFeeTo && (
                                            <FormHelperText error>{errors.parkingFeeTo}</FormHelperText>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Lot Size Acres
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.lotSizeAcres.title}
                                                ruleHelp={tips?.lotSizeAcres.ruleHelp}
                                                generalHelpDesc={tips?.lotSizeAcres.generalHelpDesc}
                                            />
                                        </Box>
                                        <TextField
                                            fullWidth
                                            name="lotSizeAcres"
                                            type="number"
                                            value={values.lotSizeAcres}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                        {touched.lotSizeAcres && errors.lotSizeAcres && (
                                            <FormHelperText error>{errors.lotSizeAcres}</FormHelperText>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Lot Dimensions (Frontage x Depth)
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.lotDimensions.title}
                                                ruleHelp={tips?.lotDimensions.ruleHelp}
                                                generalHelpDesc={tips?.lotDimensions.generalHelpDesc}
                                            />
                                        </Box>
                                        <TextField
                                            fullWidth
                                            name="lotDimensions"
                                            type="number"
                                            value={values.lotDimensions}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                        {touched.lotDimensions && errors.lotDimensions && (
                                            <FormHelperText error>{errors.lotDimensions}</FormHelperText>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth error={touched.parkingFeeFrequency && Boolean(errors.parkingFeeFrequency)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Parking Fee Frequency
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.parkingFeeFrequency.title}
                                                    ruleHelp={tips?.parkingFeeFrequency.ruleHelp}
                                                    generalHelpDesc={tips?.parkingFeeFrequency.generalHelpDesc}
                                                />
                                            </Box>

                                            <RadioGroup
                                                aria-label="parkingFeeFrequency"
                                                name="parkingFeeFrequency"
                                                value={values.parkingFeeFrequency}
                                                onChange={handleChange}
                                                row
                                                sx={{ gap: 1, ml: 1, mt: 1 }}
                                            >
                                                {parkingFeeFrequency.map((option) => (
                                                    <FormControlLabel
                                                        key={option}
                                                        value={option}
                                                        control={<Radio />}
                                                        label={option}
                                                        sx={{
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            padding: '2px 14px',
                                                            minWidth: '180px'
                                                        }}
                                                    />
                                                ))}
                                            </RadioGroup>

                                            {/* <Select
                                                    id="parkingFeeFrequency"
                                                    name=""
                                                    label="Parking Fee Frequency"
                                                    value={values.parkingFeeFrequency}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    input={<OutlinedInput />}
                                                >
                                                    {.map((option) => (
                                                        <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select> */}
                                            {touched.parkingFeeFrequency && errors.parkingFeeFrequency && (
                                                <FormHelperText>{errors.parkingFeeFrequency}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Move in Special Description
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.moveInSpecialDescription.title}
                                                ruleHelp={tips?.moveInSpecialDescription.ruleHelp}
                                                generalHelpDesc={tips?.moveInSpecialDescription.generalHelpDesc}
                                            />
                                        </Box>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            name="moveInSpecialDescription"
                                            variant="outlined"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.moveInSpecialDescription}
                                            error={touched.moveInSpecialDescription && errors.moveInSpecialDescription}
                                            helperText={<ErrorMessage name="moveInSpecialDescription" />}
                                        />

                                        {/* {touched.moveInSpecialDescription && errors.moveInSpecialDescription && (
                                            <FormHelperText error>{errors.moveInSpecialDescription}</FormHelperText>
                                        )} */}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth error={touched.waterfrontFeatures && Boolean(errors.waterfrontFeatures)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Waterfront Features
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.waterfrontFeatures.title}
                                                    ruleHelp={tips?.waterfrontFeatures.ruleHelp}
                                                    generalHelpDesc={tips?.waterfrontFeatures.generalHelpDesc}
                                                    generalHelp={tips?.waterfrontFeatures.generalHelp}
                                                />
                                            </Box>

                                            <Autocomplete
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                disableCloseOnSelect
                                                id="waterfrontFeatures"
                                                options={waterfrontFeatures}
                                                value={values.waterfrontFeatures}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('waterfrontFeatures', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="waterfrontFeatures"
                                                        error={touched.waterfrontFeatures && Boolean(errors.waterfrontFeatures)}
                                                        helperText={touched.waterfrontFeatures && errors.waterfrontFeatures}
                                                    />
                                                )}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth error={touched.waterBodyName && Boolean(errors.waterBodyName)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Water Body Name
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.waterBodyName.title}
                                                    ruleHelp={tips?.waterBodyName.ruleHelp}
                                                    generalHelpDesc={tips?.waterBodyName.generalHelpDesc}
                                                />
                                            </Box>

                                            <Autocomplete
                                                id="waterBodyName"
                                                options={waterBodyName}
                                                value={values.waterBodyName}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('waterBodyName', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="waterBodyName"
                                                        error={touched.waterBodyName && Boolean(errors.waterBodyName)}
                                                        helperText={touched.waterBodyName && errors.waterBodyName}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth error={touched.unitStyle && Boolean(errors.unitStyle)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Unit Style
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.unitStyle.title}
                                                    ruleHelp={tips?.unitStyle.ruleHelp}
                                                    generalHelpDesc={tips?.unitStyle.generalHelpDesc}
                                                    generalHelp={tips?.unitStyle.generalHelp}
                                                />
                                            </Box>

                                            <Autocomplete
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                id="unitStyle"
                                                options={unitStyle}
                                                disableCloseOnSelect
                                                value={values.unitStyle}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('unitStyle', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="unitStyle"
                                                        error={touched.unitStyle && Boolean(errors.unitStyle)}
                                                        helperText={touched.unitStyle && errors.unitStyle}
                                                    />
                                                )}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl
                                            fullWidth
                                            error={touched.distanceToWaterAccess && Boolean(errors.distanceToWaterAccess)}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Distance to Water Access
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.distanceToWaterAccess.title}
                                                    ruleHelp={tips?.distanceToWaterAccess.ruleHelp}
                                                    generalHelpDesc={tips?.distanceToWaterAccess.generalHelpDesc}
                                                    generalHelp={tips?.distanceToWaterAccess.generalHelp}
                                                />
                                            </Box>
                                            <Select
                                                id="distanceToWaterAccess"
                                                name="distanceToWaterAccess"
                                                value={values.distanceToWaterAccess}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                input={<OutlinedInput />}
                                            >
                                                {distanceToWaterAccess.map((option) => (
                                                    <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                        <ListItemText primary={option} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.distanceToWaterAccess && errors.distanceToWaterAccess && (
                                                <FormHelperText>{errors.distanceToWaterAccess}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Builder Name
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.builderName.title}
                                                ruleHelp={tips?.builderName.ruleHelp}
                                                generalHelpDesc={tips?.builderName.generalHelpDesc}
                                                // generalHelp={tips?.builderName.generalHelp}
                                            />
                                        </Box>
                                        <TextField
                                            fullWidth
                                            name="builderName"
                                            value={values.builderName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                        {touched.builderName && errors.builderName && (
                                            <FormHelperText error>{errors.builderName}</FormHelperText>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth error={touched.view && Boolean(errors.view)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        View Details
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.view.title}
                                                    ruleHelp={tips?.view.ruleHelp}
                                                    generalHelpDesc={tips?.view.generalHelpDesc}
                                                    generalHelp={tips?.view.generalHelp}
                                                />
                                            </Box>
                                            <Autocomplete
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                id="view"
                                                options={view}
                                                value={values.view}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('view', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="view"
                                                        error={touched.view && Boolean(errors.view)}
                                                        helperText={touched.view && errors.view}
                                                    />
                                                )}
                                                disableCloseOnSelect
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth error={touched.propertyCondition && Boolean(errors.propertyCondition)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Property Condition
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.propertyCondition.title}
                                                    ruleHelp={tips?.propertyCondition.ruleHelp}
                                                    generalHelpDesc={tips?.propertyCondition.generalHelpDesc}
                                                    generalHelp={tips?.propertyCondition.generalHelp}
                                                />
                                            </Box>
                                            <Autocomplete
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                id="propertyCondition"
                                                options={propertyCondition}
                                                value={values.propertyCondition}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('propertyCondition', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="propertyCondition"
                                                        error={touched.propertyCondition && Boolean(errors.propertyCondition)}
                                                        helperText={touched.propertyCondition && errors.propertyCondition}
                                                    />
                                                )}
                                                disableCloseOnSelect
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl
                                            fullWidth
                                            error={touched.constructionMaterials && Boolean(errors.constructionMaterials)}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Construction Materials
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.constructionMaterials.title}
                                                    ruleHelp={tips?.constructionMaterials.ruleHelp}
                                                    generalHelpDesc={tips?.constructionMaterials.generalHelpDesc}
                                                    generalHelp={tips?.constructionMaterials.generalHelp}
                                                />
                                            </Box>
                                            <Autocomplete
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                id="constructionMaterials"
                                                options={constructionMaterials}
                                                value={values.constructionMaterials}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('constructionMaterials', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="constructionMaterials"
                                                        error={touched.constructionMaterials && Boolean(errors.constructionMaterials)}
                                                        helperText={touched.constructionMaterials && errors.constructionMaterials}
                                                    />
                                                )}
                                                disableCloseOnSelect
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth error={touched.roof && Boolean(errors.roof)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Roof Details
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.roof.title}
                                                    ruleHelp={tips?.roof.ruleHelp}
                                                    generalHelpDesc={tips?.roof.generalHelpDesc}
                                                    generalHelp={tips?.roof.generalHelp}
                                                />
                                            </Box>
                                            <Autocomplete
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                id="roof"
                                                options={roof}
                                                value={values.roof}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('roof', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="roof"
                                                        error={touched.roof && Boolean(errors.roof)}
                                                        helperText={touched.roof && errors.roof}
                                                    />
                                                )}
                                                disableCloseOnSelect
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth error={touched.foundationDetails && Boolean(errors.foundationDetails)}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                        Foundation Details
                                                    </Typography>
                                                </FormLabel>
                                                <HelpIcon
                                                    title={tips?.foundationDetails.title}
                                                    ruleHelp={tips?.foundationDetails.ruleHelp}
                                                    generalHelpDesc={tips?.foundationDetails.generalHelpDesc}
                                                    generalHelp={tips?.foundationDetails.generalHelp}
                                                />
                                            </Box>
                                            <Autocomplete
                                                multiple
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                            sx={{
                                                                '& .MuiChip-deleteIcon': {
                                                                    color: 'black !important'
                                                                }
                                                            }}
                                                        />
                                                    ))
                                                }
                                                id="foundationDetails"
                                                options={foundationDetails}
                                                value={values.foundationDetails}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('foundationDetails', newValue);
                                                }}
                                                onBlur={handleBlur}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="foundationDetails"
                                                        error={touched.foundationDetails && Boolean(errors.foundationDetails)}
                                                        helperText={touched.foundationDetails && errors.foundationDetails}
                                                    />
                                                )}
                                                disableCloseOnSelect
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                        <ListItemText primary={option} />
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Collapse>
                    </Grid>

                    {errors.submit && (
                        <Grid item xs={12}>
                            <FormHelperText error>{errors.submit}</FormHelperText>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default General;
